// Get the loading background gradient based on variant
export const getLoadingBackground = (loadingPercentage, isInitial = false, variant) => {
  const percent = isInitial ? 0 : loadingPercentage !== undefined ? loadingPercentage : 90;

  switch (variant) {
    case "primary":
      return `linear-gradient(to right, var(--primary-cta) 0%, var(--primary-cta) ${percent}%, var(--grey-2) ${percent}%, var(--grey-2) 100%)`;
    case "tertiary":
      return `linear-gradient(to right, color-mix(in srgb, var(--primary-cta-high-contrast) 10%, transparent) 0%, color-mix(in srgb, var(--primary-cta-high-contrast) 10%, transparent) ${percent}%, transparent ${percent}%, transparent 100%)`;
    case "tertiaryGrey":
      return `linear-gradient(to right, color-mix(in srgb, var(--gray-1) 10%, transparent) 0%, color-mix(in srgb, var(--gray-1) 10%, transparent) ${percent}%, transparent ${percent}%, transparent 100%)`;
    case "secondary":
      return `linear-gradient(to right, var(--primary-cta) 0%, var(--primary-cta) ${percent}%, var(--grey-2) ${percent}%, var(--grey-2) 100%)`;
    case "secondaryGrey":
      return `linear-gradient(to right, var(--grey-0) 0%, var(--grey-0) ${percent}%, var(--grey-2) ${percent}%, var(--grey-2) 100%)`;
    case "invertedColor":
      return `linear-gradient(to right, var(--surface-inverse) 0%, var(--surface-inverse) ${percent}%, var(--surface-inverse-hover) ${percent}%, var(--surface-inverse-hover) 100%)`;
    case "invertedColorSecondary":
      return `linear-gradient(to right, var(--surface-inverse) 0%, var(--surface-inverse) ${percent}%, color-mix(in srgb, var(--surface-inverse-hover) 70%, transparent) ${percent}%, color-mix(in srgb, var(--surface-inverse-hover) 70%, transparent) 100%)`;
    default:
      return `linear-gradient(to right, var(--grey-0) 0%, var(--grey-0) ${percent}%, var(--grey-2) ${percent}%, var(--grey-2) 100%)`;
  }
};
